var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Typography } from "@mui/material";
import { BooleanInput, Edit, SimpleForm, TextField, TextInput } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { ListTenant } from "./ListTenant";
var TenantForm = function () {
    return (_jsxs(SimpleForm, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: "Customer" })), _jsx(Typography, __assign({ variant: "body2" }, { children: "Customer configuration" })), _jsx(Typography, __assign({ variant: "h5" }, { children: "ID" })), _jsx(TextField, { source: "id" }), _jsx(TextInput, { source: "slug" }), _jsx(BooleanInput, { source: "is_active" }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } })] }));
};
export var EditTenant = function () {
    return (_jsx(ListTenant, { aside: _jsx(Edit, __assign({ sx: { flexGrow: 2, width: "50%" } }, { children: _jsx(TenantForm, {}) })) }));
};
